import { render, staticRenderFns } from "./ScenarioVideoSlide.vue?vue&type=template&id=9161e562&scoped=true"
import script from "./ScenarioVideoSlide.vue?vue&type=script&lang=js"
export * from "./ScenarioVideoSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9161e562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9161e562')) {
      api.createRecord('9161e562', component.options)
    } else {
      api.reload('9161e562', component.options)
    }
    module.hot.accept("./ScenarioVideoSlide.vue?vue&type=template&id=9161e562&scoped=true", function () {
      api.rerender('9161e562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ScenarioVideoSlide.vue"
export default component.exports